import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, Mail } from "lucide-react";
import { COMPANY } from "@/lib/api";
import { HOME_IMAGES } from "@/data/images";

export function MissionCta() {
  return (
    <>
      {/* MISSION */}
      <section className="relative py-24 lg:py-32 border-t border-slate-200 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img src={HOME_IMAGES.warehouse} alt="Warehouse" className="w-full h-full object-cover" />
        </div>
        <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <div className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand mb-4">
            Our Mission
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter">
            "Dependable logistics with integrity, professionalism, and efficiency."
          </h2>
          <p className="mt-8 text-slate-600 max-w-2xl mx-auto">
            We strive to build lasting relationships with every customer through
            reliable transportation and exceptional service.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-24 border-t border-slate-200 bg-gradient-to-b from-slate-100 to-brand-bg">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="font-heading text-4xl md:text-5xl font-black tracking-tight">
              Need dependable transportation?
            </h2>
            <p className="mt-4 text-slate-600">
              Contact Laronta Pro Logistics LLC today for a free estimate.
              We'll match your load with the right truck and get it there safely.
            </p>
          </div>
          <div className="flex flex-col gap-4 md:items-end">
            <Link
              to="/quote"
              data-testid="cta-quote-btn"
              className="inline-flex items-center gap-2 bg-primary-brand hover:bg-[#E04F00] text-white px-8 py-4 font-bold uppercase tracking-wider text-sm"
            >
              Request a Free Quote <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={`tel:${COMPANY.phoneRaw}`}
              className="flex items-center gap-2 text-slate-900 hover:text-primary-brand transition-colors"
            >
              <Phone className="h-4 w-4" /> <span className="font-heading font-bold">{COMPANY.phone}</span>
            </a>
            <a
              href={`mailto:${COMPANY.email}`}
              className="flex items-center gap-2 text-slate-900 hover:text-primary-brand transition-colors text-sm"
            >
              <Mail className="h-4 w-4" /> {COMPANY.email}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
